import { useEffect } from "react";
import "./App.css";
import AzureChatBot from "./components/AzureChatBot";
import { isMobileQueryParamEnabled } from "./helpers/queryParams";
import { useEpicDynamicIframeHeight } from "./hooks/useEpicDynamicIframeHeight";

const ROUTES = {
  ROOT: "/",
  IRIS_AUTH_SUCCESS: "/auth/success",
};

const normalizePath = (pathname = window.location.pathname) =>
  pathname.replace(/\/+$/, "") || ROUTES.ROOT;

function App() {
  useEpicDynamicIframeHeight();

  const route = normalizePath();
  const isIrisAuthSuccessRoute = route === ROUTES.IRIS_AUTH_SUCCESS;
  const isMobileWebView = Boolean(
    isMobileQueryParamEnabled(
      new URLSearchParams(window.location.search).get("mobile"),
    ),
  );

  useEffect(() => {
    document.documentElement.classList.toggle(
      "mobileWebViewLayout",
      isMobileWebView,
    );

    return () => {
      document.documentElement.classList.remove("mobileWebViewLayout");
    };
  }, [isMobileWebView]);

  if (isIrisAuthSuccessRoute) {
    console.info("[IRIS handoff] Rendering auth success route.");
  }

  const appRootClassName = [
    "appRoot",
    isMobileWebView && "appRootMobileWebView",
  ]
    .filter(Boolean)
    .join(" ");

  switch (route) {
    case ROUTES.ROOT:
    case ROUTES.IRIS_AUTH_SUCCESS:
    default:
      return (
        <div className={appRootClassName}>
          <AzureChatBot />
        </div>
      );
  }
}

export default App;
